import React, {useState, useEffect} from 'react';
import Pagination from 'react-js-pagination';

const PhotoGalleryIndex = function(props){
  const [galleries, setGalleries] = useState(FW.store.get('gallery-index'));
  const [loaded, setLoaded] = useState(false);

  const sortOrder = props.section.prop('sort_order');

  useEffect(() => {
    galleries.sortOrder = props.section.prop('sort_order');
    galleries._excludeRelationships = true;
    galleries.setPageSize(props.section.prop('page_size') || 100, () => {
      setLoaded(true);
    });
  }, [sortOrder]);

  const width = props.size.width ?? 1280;

  const gals = galleries.map((gallery) => {
    let image = gallery.get('cover_photo');
    let thumbnailImage = image ? image.helper.thumbnailUrl(800) : '';
    return <div style={{width: width > 750 ? '30%' : '100%', marginBottom: 20}} key={gallery.get('id')}>
      <div style={{textAlign: 'center', fontSize: '1.5em'}}>
        <a href={'/photo-galleries/' + gallery.get('id')}>
          <div style={{height: 300, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + thumbnailImage + ')'}}></div>
        </a>
        <a href={'/photo-galleries/' + gallery.get('id')}>{gallery.get('title')}</a>
        {props.section.prop('show_description') ? <p>{gallery.get('description')}</p> : null}
      </div>
    </div>;
  });

  const pageChange = function(num){
    setLoaded(false);
    galleries.getPage(num, () => {
      setLoaded(true);
    });
  }

  return <div>
    <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between'}}>
      {gals}
      <br style={{width: '100%', clear: 'both'}} />
    </div>
    <div style={{width: '100%', textAlign: 'center'}}>
      <Pagination
        activePage={typeof galleries.pagination.number !== 'undefined' ? galleries.pagination.number : 10}
        itemsCountPerPage={props.section.prop('page_size') || 100}
        totalItemsCount={typeof galleries.pagination.total !== 'undefined' ? galleries.pagination.total : 10}
        pageRangeDisplayed={15}
        onChange={pageChange}
      />
    </div>
  </div>;
};

export default PhotoGalleryIndex;
